import axios, {AxiosRequestConfig, CancelTokenSource} from 'axios';

export const REQUEST_TIMEOUT_MS = 15000;

/** One pending request per current context; invalidate when the context leaves or changes. */
export class RequestGuard {
    private sequence = 0;
    private pending: number | null = null;
    private cancellation: CancelTokenSource | null = null;

    begin(): number | null {
        if (this.pending !== null) {
            return null;
        }
        this.pending = ++this.sequence;
        this.cancellation = axios.CancelToken.source();
        return this.pending;
    }

    isCurrent(request: number): boolean {
        return this.pending === request;
    }

    config(request: number): AxiosRequestConfig {
        if (!this.cancellation || !this.isCurrent(request)) {
            throw new Error('Request is no longer current');
        }
        return { cancelToken: this.cancellation.token, timeout: REQUEST_TIMEOUT_MS };
    }

    finish(request: number): void {
        if (this.isCurrent(request)) {
            this.pending = null;
            this.cancellation = null;
        }
    }

    invalidate(): void {
        this.pending = null;
        if (this.cancellation) {
            this.cancellation.cancel('Polling context changed');
            this.cancellation = null;
        }
    }
}
